/**
 * Session 心跳（porsche 2026-08-14）。
 * user 在互動（如 GlobeView 地圖 pan/zoom，map tiles 走外部 CDN 不打 backend）時，
 * 每 5 分 ping /session-heartbeat 刷新 session TTL，避免「一直在操作卻過期」。
 * idle（10 分無 mouse/kb/touch）時不 ping → 讓真正閒置的 session 正常逾時（active-only pattern）。
 */
import { useEffect, useRef } from 'react';
import axiosInstance from '../api/axios';

const HEARTBEAT_INTERVAL_MS = 5 * 60 * 1000;   // 每 5 分檢查
const ACTIVE_WINDOW_MS = 10 * 60 * 1000;       // 10 分內有互動 = active

export function useSessionHeartbeat(): void {
  const lastActiveRef = useRef<number>(Date.now());

  useEffect(() => {
    const onActive = () => { lastActiveRef.current = Date.now(); };
    window.addEventListener('mousemove', onActive, { passive: true });
    window.addEventListener('keydown', onActive, { passive: true });
    window.addEventListener('touchstart', onActive, { passive: true });

    const timer = window.setInterval(() => {
      if (Date.now() - lastActiveRef.current < ACTIVE_WINDOW_MS) {
        // silent ok: 心跳失敗（未登入/網路）不干擾使用；auth 攔截由 axios interceptor 統一處理
        axiosInstance.post('/api/system/session-heartbeat').catch(() => { /* silent ok: heartbeat */ });
      }
    }, HEARTBEAT_INTERVAL_MS);

    return () => {
      window.clearInterval(timer);
      window.removeEventListener('mousemove', onActive);
      window.removeEventListener('keydown', onActive);
      window.removeEventListener('touchstart', onActive);
    };
  }, []);
}
